import axios from 'axios'

const API_URL = process.env.REACT_APP_ENV === 'prod' ? process.env.REACT_APP_API_PROD_URL : process.env.REACT_APP_API_DEV_URL

export function getUpdateTableXMLData(props: any) {
  return axios.post(`${API_URL}/account/system/updatetablexml`, {...props})
}

export function downloadXMLData(props: any) {
  return axios.post(`${API_URL}/account/system/downloadxml`, {...props})
}

export function teachData(props: any) {
  return axios.post(`${API_URL}/account/system/teach`, {...props})
}

export function uploadXML(props: any) {
  return axios.post(`${API_URL}/account/system/uploadxml`, {...props})
}

export function updateStdTable(props: any) {
  return axios.post(`${API_URL}/account/system/updatestdtable`, {...props})
}

export function uploadAll(props: any) {
  return axios.post(`${API_URL}/account/system/uploadall`, {...props})
}

export function getTranslateData(props: any) {
  return axios.post(`${API_URL}/entitymetainfo/headerlabels`, {...props})
}

export function uploadLocalFiles(props: any) {
  const { file, id, salt, saltid } = props;
  const formData = new FormData();
  file && formData.append("file", file);
  id && formData.append("id", id);
  salt && formData.append("salt", salt);
  saltid && formData.append("saltid", saltid);
  return axios.post(`${API_URL}/account/system/uploadlocalfile`, formData)
}
